// extracted by mini-css-extract-plugin
export default {"loader":"loadingSpinner_loader__wmHV4","mltShdSpin":"loadingSpinner_mltShdSpin__7JAbk","round":"loadingSpinner_round__hCsqk"};